import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, map, catchError } from 'rxjs/operators';
import { ResourceService } from './resource.service';
import { Observable } from 'rxjs';
import { GlobalSettings } from '../model/settings.model';
import { AuthenticationService } from './auth.service';
import { PolicyModel } from '../model/policy.model';
import { AttributeModel } from '../main/dynamic/model/attribute.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PolicyService extends ResourceService<AttributeModel> {

  constructor(
    http: HttpClient, 
    settings: GlobalSettings, 
    authService: AuthenticationService) {
      super(http, "policies", settings.politicasUrl, authService)
  }
  
  list(): Observable<Array<AttributeModel>> {
    return this.get()
      .pipe(
        map((policies: any[]) => {
          let policiesNames = policies.map(p => {
            return {
              key: p.id,
              value: p.name
            }
          })

          sessionStorage.setItem("policies-names", JSON.stringify(policiesNames))

          return <AttributeModel[]>policies
        })
      );
  }

  listByTypePolicy(typePolicyId : string): Observable<Array<PolicyModel>> {
    return this.getWithComplement<PolicyModel[]>(`byTypePolicy/${typePolicyId}`)
  }

  read(id : string): Observable<Array<AttributeModel>> {
    return this.getBy(id).pipe(tap(console.log));
  }

  getDesignByDomain(domain: string): Observable<PolicyModel> {
    var headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("env", environment.name)

    return this.http
      .get<PolicyModel>(`${this.resourceUrl}/Design?access-code=${domain}`, { 
          headers : headers 
      })
      .pipe(
          catchError(this.handleError)
      )
  }

  getSummaryAttributes(filterName: string = "summary") {
    return this.getWithComplement<AttributeModel[]>(`Filters?keys=${filterName}`)
  }

  getExcelAttributes(filterName: string = "excel") {
    return this.getWithComplement<AttributeModel[]>(`Filters?keys=${filterName}`)
  }
}
